/** @format */
import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./LotStat.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);


const LotStat = ({ lots, onFilterClick }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { t } = useTranslation();
  const toggleCollapse = () => setIsCollapsed(!isCollapsed);




  
  const statusCounts = lots.reduce((acc, lot) => {
    const status = lot.sStatus;
    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});

  const fixedCards = [
    {
      label: `${t("Total")} ${t("Lots")}`,
      value: lots.length,
      border: "#3498db",
      filterKey: null,
    },
    
  ];

  const statusCards = Object.entries(statusCounts).map(([status, count]) => ({
    label: t(status),
    value: count,
    border: "#" + (((1 << 24) * Math.random()) | 0).toString(16),
    filterKey: status,
  }));

  const chartData = {
    labels: Object.keys(statusCounts),
    datasets: [
      {
        label: t("Nombre de lot"),
        data: Object.values(statusCounts),
        backgroundColor: [
          "rgba(255, 99, 132, 0.8)",
          "rgba(54, 162, 235, 0.8)",
          "rgba(75, 192, 192, 0.8)",
          "rgba(255, 206, 86, 0.8)",
          "rgba(153, 102, 255, 0.8)",
          "rgba(255, 159, 64, 0.8)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: "y", 
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      tooltip: { enabled: true },
    },
    scales: {
      x: { beginAtZero: true, ticks: { stepSize: 1 } },
    },
  };

  return (
    <div id="lotstat">
      <div id="lotstat_menu" onClick={toggleCollapse}>
        <div id="lotstat_menu_fleche">
          <FontAwesomeIcon icon={isCollapsed ? faChevronDown : faChevronUp} />
        </div>
        <p style={{ margin: 0, fontWeight: "bold", fontSize: "18px" }}>
          {t("Statistics")}
        </p>
      </div>

      {!isCollapsed && (
        <div id="lotstat_cadres">
          {/* Chart */}
          <div id="lotstat_chart">
            <Bar data={chartData} options={options} />
          </div>

          {/* Cards */}
          <div id="lotstat_cards">
            {[...fixedCards, ...statusCards].map((card, i) => (
              <div
                key={i}
                className="counter-card"
                onClick={() => onFilterClick?.(card.filterKey ?? "")}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.border = `1px solid ${card.border}`)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.border = "1px solid #e0e0e0")
                }
              >
                <p>{card.label}</p>
                <h3>{card.value}</h3>
          </div>
            ))}
        </div>
      </div>
         )}
    </div>
  );
};

export default LotStat;
